import API from "Classes/Api";
import { ApiGetCallParams } from "Classes/ApiCallParams";
class HealthService extends API {
  async getHealthStatus() {
    const query = {};
    const response = await super.call(
      new ApiGetCallParams({
        action: `health/default`,
        query,
        headers: { ...API.getAuthHeaders() },
      })
    );
    return response;
  }
}
const instance = new HealthService();
export default instance;
